/**************************************************
 * Nombre:       RelojProcesando
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Typography} from "@mui/material";
import Countdown from "react-countdown";

const RelojProcesando = ({fechaInicio}) => {

    const renderer = ({days, hours, minutes, seconds, completed}) => {

        return <span>{`${days}d-${hours}h-${minutes}m-${seconds}s`}</span>;

    };

    return (
        <Typography sx={{
            fontSize: 12,
            color: '#054073',
            fontWeight: 400,
            textAlign: 'center',
            lineHeight: 1.1
        }}>Se Activa en: <br/>
            <Countdown
                daysInHours={true}
                date={fechaInicio}
                renderer={renderer}
            />
        </Typography>
    )

}
export default RelojProcesando